"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CwFlyoutPointerPosition = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwDialog = _interopRequireDefault(require("./CwDialog.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwImage = _interopRequireDefault(require("../cwimage/CwImage"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var CwFlyoutPointerPosition = {
  TOP_LEFT: 'TOP_LEFT',
  TOP_RIGHT: 'TOP_RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT'
};
exports.CwFlyoutPointerPosition = CwFlyoutPointerPosition;

var CwDialog =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwDialog, _React$Component);

  function CwDialog(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwDialog);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwDialog).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDialogPosition", function (dialog) {
      if (_this.props.getDialogPosition) {
        return _this.props.getDialogPosition();
      }
      /* istanbul ignore next */


      var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
      /* istanbul ignore next */

      var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
      var left = width / 2 - (_this.props.width ? _this.props.width : dialog.offsetWidth) / 2;
      var top = height / 2 - (_this.props.height ? _this.props.height : dialog.offsetHeight) / 2;

      if (_this.props.flyoutPointerPosition) {
        left = _this.props.x;
        top = _this.props.y;
      }

      switch (_this.props.flyoutPointerPosition) {
        case CwFlyoutPointerPosition.TOP_LEFT:
          left -= 24;
          top += 8;
          break;

        case CwFlyoutPointerPosition.TOP_RIGHT:
          left += -dialog.offsetWidth + 24;
          top += 8;
          break;

        case CwFlyoutPointerPosition.BOTTOM_LEFT:
          left -= 24;
          top += -dialog.offsetHeight - 48;
          break;

        case CwFlyoutPointerPosition.BOTTOM_RIGHT:
          left += -dialog.offsetWidth + 24;
          top += -dialog.offsetHeight - 48;
          break;

        default:
          break;
      }

      return {
        top: top,
        left: left
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setDialogPosition", function () {
      var style = _this._style;

      if (_this.dialog) {
        style = _objectSpread({}, style, {}, _this.getDialogPosition(_this.dialog));

        _this.setState({
          style: style
        });
      }
    });
    _this.state = {
      style: null
    };
    _this._style = null;
    return _this;
  }

  (0, _createClass2.default)(CwDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("resize", this.setDialogPosition);
      this.setDialogPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.setDialogPosition);
    }
  }, {
    key: "render",
    value: function render() {
      var _cx,
          _this2 = this;

      var dialogClass = (0, _classnames.default)((_cx = {}, (0, _defineProperty2.default)(_cx, _CwDialog.default.modal, !this.props.flyoutPointerPosition), (0, _defineProperty2.default)(_cx, _CwDialog.default.flyoutTopLeft, this.props.flyoutPointerPosition === CwFlyoutPointerPosition.TOP_LEFT), (0, _defineProperty2.default)(_cx, _CwDialog.default.flyoutTopRight, this.props.flyoutPointerPosition === CwFlyoutPointerPosition.TOP_RIGHT), (0, _defineProperty2.default)(_cx, _CwDialog.default.flyoutBottomLeft, this.props.flyoutPointerPosition === CwFlyoutPointerPosition.BOTTOM_LEFT), (0, _defineProperty2.default)(_cx, _CwDialog.default.flyoutBottomRight, this.props.flyoutPointerPosition === CwFlyoutPointerPosition.BOTTOM_RIGHT), _cx));
      var style = this.props.style;
      style = _objectSpread({}, style, {
        height: this.props.height,
        width: this.props.width,
        left: this.props.x,
        top: this.props.y,
        zIndex: this.props.zIndex
      });
      this._style = style;
      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        className: dialogClass,
        style: this.state.style,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        ref: function ref(dialog) {
          return _this2.dialog = dialog;
        }
      }, this.props.includeCloseIcon ? _react.default.createElement(_CwImage.default, {
        className: (0, _classnames.default)('CwThemeFill', _CwDialog.default.closeIcon),
        src: this.props.closeIcon,
        onClick: this.props.onCloseIconClicked
      }) : null, _react.default.createElement("div", {
        className: _CwDialog.default.wrap
      }, _react.default.createElement("div", {
        className: _CwDialog.default.header
      }, this.props.header), this.props.subHeader ? _react.default.createElement("div", {
        className: _CwDialog.default.subHeader
      }, this.props.subHeader) : null, this.props.children ? _react.default.createElement("div", {
        className: _CwDialog.default.content
      }, this.props.children) : null, this.props.buttons ? _react.default.createElement("div", {
        className: _CwDialog.default.buttons
      }, " ", this.props.buttons, " ") : null));
    }
  }]);
  return CwDialog;
}(_react.default.Component);

CwDialog.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Content to be shown in the Dialog
   */
  children: _propTypes.default.any,

  /**
   * Array of buttons aligned in the bottom right corner
   */
  buttons: _propTypes.default.arrayOf(_propTypes.default.element),

  /**
   * The primary header of the dialog box
   */
  header: _propTypes.default.string.isRequired,

  /**
   * Specifies the height of the dialog box
   */
  height: _propTypes.default.number,

  /**
   * Specifies the position of the fly-out pointer
   */
  flyoutPointerPosition: _propTypes.default.oneOf([CwFlyoutPointerPosition.TOP_LEFT, CwFlyoutPointerPosition.TOP_RIGHT, CwFlyoutPointerPosition.BOTTOM_LEFT, CwFlyoutPointerPosition.BOTTOM_RIGHT]),

  /**
   * The secondary header of the dialog box
   */
  subHeader: _propTypes.default.string,

  /**
   * Specifies the width of the dialog box
   */
  width: _propTypes.default.number,

  /**
   * Specifies the x coordinate of the dialog box
   */
  x: _propTypes.default.number,

  /**
   * Specifies the y coordinate of the dialog box
   */
  y: _propTypes.default.number,

  /**
   * Specifies the z-index of the dialog box
   */
  zIndex: _propTypes.default.number,

  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes.default.func,

  /**
   * True to include close icon on top right of dialog
   */
  includeCloseIcon: _propTypes.default.bool,

  /**
   * Icon for close button on top right
   */
  closeIcon: _propTypes.default.string,

  /**
   * Callback function for close button clicked.
   * Consumer should use this prop to close/hide dialog
   */
  onCloseIconClicked: _propTypes.default.func,

  /**
   * Custom positioning function.
   * Will likely need to be overridden for flyout dialogs due to the
   * way Microsoft Edge calculates dialog.offsetWidth
   */
  getDialogPosition: _propTypes.default.func
};
CwDialog.defaultProps = {
  zIndex: 1
};
var _default = CwDialog;
exports.default = _default;